import React from "react";

function FeaturesButtons() {
	return (
		<div className="buttonsContainer">
			<button id="exploreBtn">Explore</button>
			<button id="joinBtn">{"Join Now >"}</button>
		</div>
	);
}

export default FeaturesButtons;
